module.exports = __webpack_public_path__ + "static/media/robles.2f57ba2f.webp";